import React, {useEffect, useState} from "react";
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import Divider from '@material-ui/core/Divider';
import Progress from "../../../../../ui/Progress";
import StateInfoField from "./StateInfoField";
import {SmallStateIcon, StateName, StateTextColor} from "../../../components/StateStyles";
import {getRelationRequestList, getRequestMainInfo} from "../../../store/actions";
import {connect} from "react-redux";
import Chip from '@material-ui/core/Chip';
import {format, parseISO} from "date-fns";
import ru from "date-fns/locale/ru";
import RelationRequestsTable from "../RequestRelations/RelationRequestsTable";

const useStyles = makeStyles(() => ({
  root: {
    paddingLeft: 8,
    //width: 774,
    "& .MuiFormLabel-root": {
      whiteSpace: "nowrap"
    },
    "& .MuiInputBase-input.Mui-disabled": {
      color: "#000"
    }
  },
  link: {
    color: "#007FBD"
  },
  progress: {
    display: "flex",
    justifyContent: "center"
  },
  heading: {
    fontSize: 14,
    lineHeight: "18px",
    display: "flex",
    alignItems: "center",
    color: "#000000",
    margin: "8px 0"
  },
  heading16: {
    fontSize: 16,
    fontWeight: 400,
    lineHeight: "18px",
    display: "flex",
    alignItems: "center",
    color: "#000000",
    margin: "8px 0"
  },
  block: {
    margin: "0 0 32px 0"
  },
  blockrow: {
    marginTop: 24
  },
  blockfieldValue: {
    marginTop: 8
  },
  checkbox: {
    "& > .MuiCheckbox-colorPrimary.Mui-checked": {
      color: "rgba(0, 127, 189, 0.7);"
    }
  },
  label: {
    fontSize: 12
  },
  svgIcon:{
    display: "inline-block",
    marginBottom: "-8px",
    marginRight: "8px"
  },
  typofield: {
    width: 120,
    minWidth: 120,
    paddingRight: 16
  },
  typovalue: {
    fontSize: 12,
  }
}));

const formatDate = date =>
  date ? format(parseISO(date), "dd.MM.yyyy", { locale: ru }) : null;

const StudyRequestInfo = ({
                            requestId,
                            getRequestMainInfo,
                            requestMain,
                            getRelationRequestList,
                            relRequestList,
}) => {
const classes = useStyles();

  useEffect(() => {
    if (requestId) {
      getRequestMainInfo(requestId);
      getRelationRequestList(requestId);
    }
  }, [requestId]);

return (
  <div className={classes.root}>
    {requestMain ? <>
      <Grid container spacing={1}>
          <Grid item xs={12} sm={6}>
            <Typography className={classes.heading}>Основные параметры заявки</Typography>
            <StateInfoField field="Номер" value={requestMain.id}/>
            <StateInfoField field="Дата подачи" value={formatDate(requestMain.date)}/>
            <StateInfoField field="Регион" value={requestMain.regionName}/>
            {requestMain.work &&
            <StateInfoField field="Специалист" value={requestMain.work.personName}/>
            }
            <div style={{marginTop: 8, display: "flex", alignItems: "flex-start"}}>
              <Typography
                style={{width: 130, minWidth: 130, marginRight: 16}}
                variant="caption"
                color="textSecondary"
              >
                Текущий статус
              </Typography>
              <Typography style={{fontSize: 12}} variant="caption">
                <Chip color="primary"
                      style={{ "background": StateTextColor(requestMain.status)}}
                      size="small"
                      icon={SmallStateIcon(requestMain.status)}
                      label={StateName(requestMain.status)}/>
              </Typography>
            </div>
          </Grid>
        {requestMain.myProgram &&
        <Grid item xs={12} sm={6}>
          <Typography className={classes.heading}>Рабочая программа</Typography>
          <StateInfoField field="Код программы" value={requestMain.myProgram.code || '-'}/>
          <StateInfoField field="Наименование" value={requestMain.myProgram.name}/>
          <StateInfoField field="Целевая аудитория" value={requestMain.myProgram.targetGroup}/>
          <StateInfoField field="Компетенция" value={requestMain.myProgram.competence}/>
          <StateInfoField field="Организация" value={requestMain.myOrganization ? requestMain.myOrganization.name : '-'}/>
        </Grid>}
        {requestMain.student &&
          <Grid item xs={12} sm={6}>
            <Typography className={classes.heading}>Данные заявителя</Typography>
            <StateInfoField field="ФИО" value={requestMain.student.name}/>
            <StateInfoField field="Дата рождения" value={requestMain.student.birthDate ? formatDate(requestMain.student.birthDate) : '-'}/>
            <StateInfoField field="СНИЛС" value={requestMain.studentSnils || '-'}/>
            <StateInfoField field="Телефон" value={requestMain.student.phone || '-'}/>
            <StateInfoField field="E-mail" value={requestMain.student.email || '-'}/>
          </Grid>}
        {(requestMain.targetAudience === "schoolchild") && <>
        {requestMain.schoolchild &&
          <Grid item xs={12} sm={6}>
            <Typography className={classes.heading}>Данные школьника</Typography>
            <StateInfoField field="ФИО" value={requestMain.schoolchild.name}/>
            <StateInfoField field="Дата рождения" value={requestMain.schoolchild.birthDate ? formatDate(requestMain.schoolchild.birthDate) : '-'}/>
            <StateInfoField field="СНИЛС" value={requestMain.studentSnils || '-'}/>
            <StateInfoField field="Школа" value={requestMain.schoolchild.school || '-'}/>
            <StateInfoField field="Класс" value={requestMain.schoolchild.class || '-'}/>
            <StateInfoField field="Смена" value={requestMain.schoolchild.shift}/>
            <StateInfoField field='Участвовал в программе "Первая профессия"' value={requestMain.schoolchild.gotFreeProfession ? "Получена" : "Нет"}/>
          </Grid>}
        {requestMain.schoolchildParent &&
          <Grid item xs={12} sm={6}>
            <Typography className={classes.heading}>Данные представителя школьника</Typography>
            <StateInfoField field="ФИО" value={requestMain.schoolchildParent.name}/>
            <StateInfoField field="Телефон" value={requestMain.schoolchildParent.phone || '-'}/>
            <StateInfoField field="E-mail" value={requestMain.schoolchildParent.email || '-'}/>
          </Grid>}
          </>}
      </Grid>
        <br/>
        <Divider/>
        <br/>
        <div className={classes.block}>
          <Typography className={classes.heading}>
            Похожие заявки на обучение
            {(relRequestList && relRequestList.length > 0) ?
              ` (найдено совпадений: ${relRequestList.length})`
              : ' (совпадений не найдено)'
            }
          </Typography>
          {(relRequestList && relRequestList.length > 0) &&
            <RelationRequestsTable relRequestList={relRequestList}/>
          }
        </div>
      </>
    : <Progress/>}
  </div>
)}

const mapStateToProps = state => ({
  requestMain: state.studyRequests.requestMain,
  isFetchingWorkProcess: state.studyRequests.isFetchingWorkProcess,
  relRequestList: state.studyRequests.relRequestList
});

const mapDispatchToProps = dispatch => ({
  getRequestMainInfo: (id) => dispatch(getRequestMainInfo(id)),
  getRelationRequestList: (id) => dispatch(getRelationRequestList(id))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(StudyRequestInfo)
